const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/board-reports.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { css } from "@packages/panda-generated/css";
import { createFileRoute } from "@tanstack/react-router";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
export const Route = createFileRoute("/_app/board-reports")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const nextStep = {
  "": "asc",
  asc: "desc",
  desc: ""
} as const;
export const SortItem = ({
  sorting,
  type,
  onChange
}: {
  sorting: boolean;
  type: "asc" | "desc" | "";
  onChange?: (type: "" | "asc" | "desc") => void;
}) => {
  const handleClick = () => {
    const next = nextStep[type];
    if (typeof onChange === "function") {
      onChange(next);
    }
  };
  return <div onClick={handleClick}>
      {sorting ? {
      "": <FaSort className={css({
        color: "gray.400"
      })} />,
      asc: <FaSortUp />,
      desc: <FaSortDown />
    }[type] : <FaSort className={css({
      color: "gray.400"
    })} />}
    </div>;
};